import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * renderer de libellé avec icones déprécié et supprimé logiquement
 */
@Component({
  selector: 'ag-code-flag-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center">
    <wiz-label [wizLabel]="data.trsLabel" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
    <!-- TODO remplacer l'icon cancel -->
    <wiz-icon *ngIf="deleted" height="16px">icon-cancel</wiz-icon>
    <wiz-spacer *ngIf="!deleted" height="16px" width="16px"></wiz-spacer>

    <wiz-icon *ngIf="deprecated" height="16px">icon-deprecated</wiz-icon>
    <wiz-spacer *ngIf="!deprecated" height="16px" width="16px"></wiz-spacer>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgLabelValidityRenderer implements AgRendererComponent {
  data: any;

  /**
   * renderer back pour deprecated / deleted
   */
  public get deprecated() {
    return this.data && this.data.deprecated;
  }
  public get deleted() {
    return this.data && this.data.deleted;
  }

  constructor(private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.cdref.markForCheck();
  }
}
